<div id="content" class="extensible">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="page-title">
          <h1>
            {{ page_title }}
            <span class="page-title-separator">/</span>
            {{ active_section_label() }}
          </h1>
          <div class="page-title-actions">
            @if (back_companies_link) {
              <button mat-flat-button class="page-title-back-button" [routerLink]="back_companies_link" type="button">
                <mat-icon matPrefix>arrow_back</mat-icon>
                Volver
              </button>
            }
            @for (action of header_actions(); track action.label) {
              @if (action.variant === 'stroked') {
                <button
                  mat-stroked-button
                  [color]="action.color"
                  [disabled]="action.disabled === true"
                  (click)="action.on_click()"
                  type="button"
                >
                  <mat-icon matPrefix>{{ action.icon }}</mat-icon>
                  {{ action.label }}
                </button>
              } @else {
                <button
                  mat-flat-button
                  [color]="action.color"
                  [disabled]="action.disabled === true"
                  (click)="action.on_click()"
                  type="button"
                >
                  <mat-icon matPrefix>{{ action.icon }}</mat-icon>
                  {{ action.label }}
                </button>
              }
            }
          </div>
        </div>
      </div>
    </div>

    <div class="company-detail-layout">
      <nav aria-label="Secciones de la empresa">
        <ul>
          @for (section of visible_company_detail_sections(); track section) {
            <li [class.active]="active_section() === section">
              <button type="button" (click)="select_section(section)">
                {{ company_detail_section_enum_labels[section] }}
              </button>
            </li>
          }
        </ul>
      </nav>

      <div class="company-detail-content">
        @if (company_loaded()) {
          @switch (active_section()) {
            @case (company_detail_section_enum.General) {
              <form class="card mb-5" [formGroup]="company_form">
                <div class="container section-container">
                  <h3 class="section-subtitle">Datos de contacto</h3>
                  <div class="row">
                    <div class="col-12 col-lg-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Correo electrónico</mat-label>
                        <input type="email" matInput formControlName="email" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-4">
                      <mat-form-field appearance="outline">
                        <mat-label>Teléfono móvil</mat-label>
                        <input type="tel" matInput placeholder="+34.666 555 444" formControlName="phone" />
                        <mat-icon matSuffix>phone</mat-icon>
                        <mat-hint>F: +XX.XXX XXX XXX</mat-hint>
                      </mat-form-field>
                    </div>
                  </div>

                  <h3 class="section-subtitle">Datos de facturación</h3>
                  <div class="row">
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Nombre de facturación</mat-label>
                        <input type="text" matInput formControlName="fact_name" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>NIF/CIF</mat-label>
                        <input type="text" matInput formControlName="vat" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Dirección de facturación</mat-label>
                        <input type="text" matInput formControlName="fact_address" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Población/Ciudad</mat-label>
                        <input type="text" matInput formControlName="fact_city" />
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Código postal</mat-label>
                        <input type="text" matInput formControlName="fact_zipcode" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>Província</mat-label>
                        <input type="text" matInput formControlName="fact_county" />
                      </mat-form-field>
                    </div>
                    <div class="col-12 col-lg-3">
                      <mat-form-field appearance="outline">
                        <mat-label>País</mat-label>
                        <mat-select formControlName="fact_country">
                          @for (c of countries; track c.alpha_2) {
                            <mat-option [value]="c.name">{{ c.name }}</mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </form>
            }
            @case (company_detail_section_enum.Users) {
              <div class="card mb-5">
                <div class="container section-container">
                  <table mat-table [dataSource]="usersDataSource">
                    <ng-container matColumnDef="name">
                      <th mat-header-cell *matHeaderCellDef>Nombre</th>
                      <td mat-cell *matCellDef="let user">{{ user.name }}</td>
                    </ng-container>
                    <ng-container matColumnDef="email">
                      <th mat-header-cell *matHeaderCellDef>Email</th>
                      <td mat-cell *matCellDef="let user">{{ user.email }}</td>
                    </ng-container>
                    <ng-container matColumnDef="role">
                      <th mat-header-cell *matHeaderCellDef>Rol</th>
                      <td mat-cell *matCellDef="let user">{{ user.role.name }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let user">
                        <button mat-icon-button [matMenuTriggerFor]="userMenu" type="button">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #userMenu="matMenu">
                          <button mat-menu-item [routerLink]="['/employees', 'direction', 'users', user.id]">
                            <mat-icon>person</mat-icon>
                            <span>Ver usuario</span>
                          </button>
                        </mat-menu>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="usersDisplayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: usersDisplayedColumns"></tr>
                  </table>
                </div>
              </div>
            }
            @case (company_detail_section_enum.MessagingConversations) {
              <div class="card mb-5">
                <div class="container section-container">
                  <p class="text-muted mb-3">
                    Slack llega por sync del workspace. Google Chat por asignación pendiente. Aquí puedes listar y crear solo Teams
                    (webhook).
                  </p>
                  <table mat-table [dataSource]="messaging_conversations_data_source">
                    <ng-container matColumnDef="provider">
                      <th mat-header-cell *matHeaderCellDef>Provider</th>
                      <td mat-cell *matCellDef="let row">{{ row.provider }}</td>
                    </ng-container>
                    <ng-container matColumnDef="display_name">
                      <th mat-header-cell *matHeaderCellDef>Nombre</th>
                      <td mat-cell *matCellDef="let row">{{ row.display_name }}</td>
                    </ng-container>
                    <ng-container matColumnDef="active">
                      <th mat-header-cell *matHeaderCellDef>Activo</th>
                      <td mat-cell *matCellDef="let row">{{ row.active ? 'Sí' : 'No' }}</td>
                    </ng-container>
                    <ng-container matColumnDef="actions">
                      <th mat-header-cell *matHeaderCellDef></th>
                      <td mat-cell *matCellDef="let row">
                        <button mat-icon-button [matMenuTriggerFor]="mcMenu" type="button">
                          <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #mcMenu="matMenu">
                          <button mat-menu-item (click)="deleteMessagingConversation(row)">
                            <mat-icon>delete</mat-icon>
                            <span>Borrar</span>
                          </button>
                        </mat-menu>
                      </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="messaging_conversations_displayed_columns"></tr>
                    <tr mat-row *matRowDef="let row; columns: messaging_conversations_displayed_columns"></tr>
                  </table>
                </div>
              </div>
            }
            @case (company_detail_section_enum.Communications) {
              <app-company-detail-slack-section
                [company_id]="company_id"
                [slack_external_tenant_id]="slack_external_tenant_id()"
                [can_edit]="can_manage_slack()"
                (tenant_saved)="on_tenant_saved($event)"
              />
            }
            @case (company_detail_section_enum.Locations) {
              <div class="card mb-5">
                <div class="container section-container">
                  <app-locations-management
                    [tab_layout]="true"
                    [hide_title]="true"
                    [relatable_type]="company_relatable_type"
                    [relatable_id]="+company_id"
                  />
                </div>
              </div>
            }
          }
        }
      </div>
    </div>
  </div>
</div>
